export const prices = [
    {
        _id: 0,
        name: "Any",
        array: []
    },
    {
        _id: 1,
        name: "₹100 to ₹199",
        array: [100, 199]
    },
    {
        _id: 2,
        name: "₹200 to ₹299",
        array: [200, 299]
    },
    {
        _id: 3,
        name: "₹300 to ₹999",
        array: [300, 999]
    },
    {
        _id: 4,
        name: "₹1000 to ₹4999",
        array: [1000, 4999]
    },
    {
        _id: 5,
        name: "more than ₹5000 ",
        array: [5000, 15000]
    },

]